<template>
  <div class="radio-button__input">
    <label class="radio-button__label">{{ label }}</label>
    <div class="radio-button__wrapper">
      <div 
        v-for="option in options" 
        :key="option.key" 
        :class="`radio-button__custom d-flex ${localValue === option.key ? 'checked': ''}`"
        @click="localValue = option.key"
      >
        <div class="radio-button__content">
          <i :class="`mc-fa ${option.icon}`" />
          <span>{{ option.label }}</span>
        </div>
        <McRadioButton
          :id="option.key"
          v-model="localValue"
          :name="name"
          :initialValue="option.key"
          :fullWidth="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import McRadioButton from '@/components/McRadioButton'

export default {
  components: {
    McRadioButton,
  },
  props: {
    value: {
      type: [Number, String],
      default: undefined,
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    options: {
      type: [Array],
      required: true,
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.radio-button__label {
  color: $mep-color-text-300;
}

.radio-button__input {
  padding: 4px;
  color: $mep-color-text-400;
}

.radio-button__wrapper {
  display: flex;
  gap: 12px;
}

.radio-button__custom {
  padding: 8px 12px;
  height: fit-content;
  align-items: center;
  gap: 8px;

  border: 1px solid $border-color;
  border-radius: 4px;
  cursor: pointer;

  width: 100%;
  max-width: 240px;

  justify-content: space-between;

  :deep(.custom-radio) label {
    margin-bottom: 2px;
  }

  .mc-fa {
    font-size: 16px;
  }
}

.radio-button__content {
  display: flex;
  align-items: center;
  gap: 4px;
}

.checked {
  background-color: $cyan-100;
  border-color: $mep-primary-300;
  font-weight: 600;
}
</style>